import { DEVTOOLS_ENABLED } from "@/shared/config/env"

function referralServiceUrl(): string {
	if (DEVTOOLS_ENABLED) return "https://go-dev.luni-tg.ru"
	return "https://go.luni.monster"
}

export const REFERRAL_SERVICE_URL = referralServiceUrl()
